import React, { Component } from 'react';
import apiData from 'Lib/apiData';
import cmsData from 'Lib/cmsData';
import { withAuth } from '../components/auth';
import CreateHero from '../components/create-fundraiser/create-hero';
import Account from '../components/create-fundraiser/account';
import CreateFundraiserForm from '../components/create-fundraiser/create-fundraiser-form';
import Seo from '../components/seo';

class CreateFundraiser extends Component {

  static async getInitialProps() {
    const contentParams = {
      content_type: 'createForms',
      'fields.formName': 'fundraiser',
      include: 3,
    };

    const [data, programs] = await Promise.all([
      cmsData(contentParams),
      apiData('/v1/projects?type=1'),
    ]);

    return { data: data && data[0], programs };
  }

  state = {
    user: null,
  }

  componentDidMount() {
    if (this.props.loggedIn) {
      this.getUser();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loggedIn !== this.props.loggedIn) {
      if (this.props.loggedIn) {
        this.getUser();
      } else {
        this.removeUser();
      }
    }
  }

  getUser = () => {
    apiData(`/v1/users/${this.props.loggedIn}`)
      .then((response) => {
        this.setState({
          user: response,
        });
      });
  }

  removeUser = () => {
    this.setState({
      user: null,
    });
  }

  render() {
    const { data, programs, loggedIn } = this.props;

    return (
      <main style={{ overflow: 'hidden' }}>
        <Seo seo={data.fields.seo} />
        <CreateHero
          subheading={data.fields.heroSubheading}
          title={data.fields.heroTitle}
          images={data.fields.heroPhotos}
        />
        <Account
          user={this.state.user}
          loggedInContent={data.fields.accountLoggedIn}
          loggedOutContent={data.fields.accountStep}
        />
        <CreateFundraiserForm
          programs={programs}
          loggedIn={loggedIn}
          stepContent={data.fields.formStepContent}
        />
      </main>
    );
  }
}

export default withAuth(CreateFundraiser);
